import AuthSimpleLayout from 'layouts/AuthSimpleLayout';
import ActivateUser from './components/ActivateUser';

const SignUpFinalize = () => {

    return (
        <AuthSimpleLayout>
            <ActivateUser />
        </AuthSimpleLayout>
    );
};

export default SignUpFinalize;
